import { render, staticRenderFns } from "./ServiceRequestToday.vue?vue&type=template&id=38eeafe4&"
import script from "./ServiceRequestToday.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports